import type { AppDispatch } from '../store/store';
import { hydrateCartIfNeeded } from '../store/cartSlice';

/** Request cart hydration on user intent (cart icon, drawer, etc.). */
export function requestCartHydration(dispatch: AppDispatch): void {
  void dispatch(hydrateCartIfNeeded());
}
